import { IdeaDateTime, IIdeaDatetimeStruct } from "@ideatech/ngx-ideatech";
import { IWSDateTime } from "../interfaces/ws-datetime.interface";

export class WSDateTime implements IWSDateTime {

    private readonly DATE_DELIMITER = '/';
    private readonly TIME_DELIMITER = ':';

    get dateStringValue(): string {
        if (this.hasValue && this.day !== undefined && this.month !== undefined && this.year !== undefined) {
            return `${this.day.toString().padStart(2, '0')}${this.DATE_DELIMITER}${this.month.toString().padStart(2, '0')}${this.DATE_DELIMITER}${this.year.toString().padStart(2, '0')}`;
        } else {
            return "";
        }
    }
    get stringValue(): string {
        if (this.hasValue) {
            const dateString = this.dateStringValue;
            const timeString = `${(this.hour ?? 0).toString().padStart(2, '0')}${this.TIME_DELIMITER}${(this.minute ?? 0).toString().padStart(2, '0')}${this.TIME_DELIMITER}${(this.second ?? 0).toString().padStart(2, '0')}`
            return `${dateString} ${timeString}`;
        } else {
            return "";
        }
    }
    get hasValue(): boolean {
        return !!this.year || !!this.month || !!this.day || !!this.hour || !!this.minute || !!this.second;
    }

    constructor(
        public day?: number,
        public month?: number,
        public year?: number,
        public hour?: number,
        public minute?: number,
        public second?: number
    ) {}

    static from(value?: IWSDateTime | null): WSDateTime {
        if (!value) {
            return new WSDateTime();
        } else if (value instanceof WSDateTime)  {
            return value;
        } else {
            return new WSDateTime(value.day, value.month, value.year, value.hour, value.minute, value.second);
        }
    }

    toObject(): IWSDateTime {
        return {
            day: this.hasValue ? (this.day || 0) : this.day,
            month: this.hasValue ? (this.month || 0) : this.month,
            year: this.hasValue ? (this.year || 0) : this.year,
            hour: this.hasValue ? (this.hour || 0) : this.hour,
            minute: this.hasValue ? (this.minute || 0) : this.minute,
            second: this.hasValue ? (this.second || 0) : this.second,
            hasValue: this.hasValue,
            dateStringValue: this.dateStringValue,
            stringValue: this.stringValue
        }
    }

}
